export default {
  bind(element, { value, modifiers }, vnode) {
    function handler(e) {
      if (!e.target.value.startsWith(value)) {
        e.target.value = `${value}${e.target.value}`;

        vnode.elm.dispatchEvent(new CustomEvent('input'));
      }
    }

    function keyPress (e) {
      if(e.key === 'Escape') {
        handler(e);
      }
    }

    if (!value) {
      return;
    }

    let hasValue = modifiers.prefill || !!element.value;
    element.addEventListener('input', handler);
    element.addEventListener('focus', handler);
    element.addEventListener('keydown', keyPress);

    if (!element.value) {
      element.value = value;
    }

    if (hasValue) {
      vnode.elm.dispatchEvent(new CustomEvent('input'));
    }
  },
};